import { productQueryKey } from "../api/products";
let heroSeed = null;
export function readPublicHero(now = Date.now()) {
  return heroSeed && now >= heroSeed.at && now - heroSeed.at < 20_000 ? heroSeed.slides : null;
}

// Server public HTML contains only anonymous, allowlisted catalogue facts.
// Signed-in viewers always fetch under their own existing account-specific key.
export function seedPublicProduct(queryClient, doc = document, now = Date.now()) {
  const node = doc.getElementById("public-catalogue");
  if (!node) return;
  try {
    const { product, hero, fetchedAt } = JSON.parse(node.textContent);
    if (!Number.isFinite(fetchedAt) || fetchedAt > now || now - fetchedAt > 60_000) return;
    if (Array.isArray(hero) && now - fetchedAt < 20_000) heroSeed = { slides: hero, at: fetchedAt };
    if (!product?.id || !product.name || !Number.isFinite(product.price)) return;
    const slug = product.slug || product.id;
    queryClient.setQueryData(productQueryKey(slug), product, { updatedAt: fetchedAt });
  } catch { /* A damaged bootstrap must never prevent React starting. */ }
  finally { node.remove(); }
}
